import { NavigateFunction } from "react-router-dom";
import { AxiosError } from "axios";
import { StatusCodes } from "http-status-codes";

export const getErrorStatusCode = (error: unknown) =>
  (error instanceof AxiosError
    ? error.response?.status
    : error instanceof Response && error.status) ||
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  error?.status ||
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  error?.Code ||
  -1;

export const getButtonCallback = (
  statusCode: number,
  navigate: NavigateFunction,
) => {
  switch (statusCode) {
    case StatusCodes.FORBIDDEN:
    case StatusCodes.UNAUTHORIZED:
      return () => navigate(-1);
    default:
      return () => window.location.reload();
  }
};
